import { MeasurementUnits } from "../measurement";
import { OptionalProperties } from "../json/optional-properties";
import { materialDefaults, MaterialOptions } from "../views/views-config";

export interface MeasurementUnitsConfig {
    units: MeasurementUnits,
};

export type StyleDefaultsConfig = {
    base: string,
    crown: string,
    doorFrame: string,
    doorPanel: string,
    drawerFrame: string,
    drawerPanel: string,
    drawerSlabPanel: string,
    fence: string,
    hardware: string,
    rod: string,
}
export type StyleDefaultsOptions = OptionalProperties<StyleDefaultsConfig>;

export const styleDefaultsDefaults: StyleDefaultsConfig = {
    base: null,
    crown: null,
    doorFrame: "frame_original_2in",
    doorPanel: "panel_plain_0.125in",
    drawerFrame: "frame_original_2in",
    drawerPanel: "panel_plain_0.125in",
    drawerSlabPanel: "panel_plain_0.75in",
    fence: "Fence.obj",
    hardware: "pulls/standard-pull",
    rod: "Rod.obj",
}

export type MaterialsDefaultsConfig = {
    backing: MaterialOptions,
    base: MaterialOptions,
    basket: MaterialOptions,
    crown: MaterialOptions,
    door: MaterialOptions,
    drawer: MaterialOptions,
    drawerBox: MaterialOptions,
    edgeband: MaterialOptions,
    fence: MaterialOptions,
    hamper: MaterialOptions,
    hardware: MaterialOptions,
    light: MaterialOptions,
    melamineCountertop: MaterialOptions,
    rod: MaterialOptions,
    shelving: MaterialOptions,
    spinner: MaterialOptions,
    tagCanvas: MaterialOptions,
    tagFrame: MaterialOptions,
    tagCurateFabric: MaterialOptions,
    tagLeatherInsert: MaterialOptions,
    tagMeshInsert: MaterialOptions,
    tagBlack: MaterialOptions,
    toeKick: MaterialOptions,
    vertical: MaterialOptions,
}
export type MaterialsDefaultsOptions = OptionalProperties<MaterialsDefaultsConfig>;

export const materialsDefaultsDefaults: MaterialsDefaultsConfig = {
    backing: {
        "color": "/closet-organizers-images/models/colors/2.png",
        "type": "StandardMelamine"
    },
    base: {
        "color": "/closet-organizers-images/models/colors/2.png",
        "type": "StandardMelamine"
    },
    basket: {
        "type": "Chrome"
    },
    crown: {
        "color": "/closet-organizers-images/models/colors/2.png",
        "type": "StandardMelamine"
    },
    door: {
        "color": "/closet-organizers-images/models/colors/2.png",
        "type": "StandardMelamine"
    },
    drawer: {
        "color": "/closet-organizers-images/models/colors/2.png",
        "type": "StandardMelamine"
    },
    drawerBox: {
        "color": "/closet-organizers-images/models/colors/358.png",
        "type": "StandardMelamine"
    },
    edgeband: {
        "color": "/closet-organizers-images/models/colors/2.png",
        "type": "StandardMelamine"
    },
    fence: {
        "type": "Chrome"
    },
    hamper: materialDefaults,
    hardware: {
        "type": "Chrome"
    },
    light: {
         "type": "LightNeutral"
    },
    melamineCountertop: materialDefaults,
    rod: {
        "type": "Chrome"
    },
    shelving: {
        "color": "/closet-organizers-images/models/colors/2.png",
        "type": "StandardMelamine"
    },
    spinner: materialDefaults,
    tagCanvas: {
        "color": "/closet-organizers-images/models/TAG/Slate.png",
        "type": "GenericAsset",
        "slot": "canvas"
    },
    tagFrame: {
        "assetId": "materials/matte-aluminum",
        "slot": "frame"
    },
    tagCurateFabric: {
        "color": "/closet-organizers-images/models/TAG/Curate.png",
        "type": "GenericAsset",
        "slot": "insert"
    },
    tagLeatherInsert: {
        "type": "LeatherOyster",
        "slot": "insert"
    },
    tagMeshInsert: {
        "assetId": "materials/fabric-mesh-square",
        "slot": "insert"
    },
    tagBlack: {
        "type": "GlossBlack",
        "slot": "black"
    },
    toeKick: {
        "color": "/closet-organizers-images/models/colors/2.png",
        "type": "StandardMelamine"
    },
    vertical: {
        "color": "/closet-organizers-images/models/colors/2.png",
        "type": "StandardMelamine"
    },
}

export type DefaultsConfig = {
    styles: StyleDefaultsConfig,
    materials: MaterialsDefaultsConfig,
}
export type DefaultsOptions = OptionalProperties<DefaultsConfig>;

export const defaultsDefaults: DefaultsConfig = {
    styles: styleDefaultsDefaults,
    materials: materialsDefaultsDefaults,
}
